// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-heading_default__2o29o","icon":"idt-heading_icon__28_qf"};